import ApiService, { getCancelable } from '../core/api';

const ApiConcurrencyService = function() {
  this.api = ApiService;
  this.cancelables = [];

  this.add = function add(cancelable) {
    this.cancelables.push(cancelable);
  };

  this.abortAll = function abortAll() {
    this.cancelables.forEach(cancelable => {
      cancelable.cancel('CANCELED');
    });
  };
};

ApiConcurrencyService.prototype.get = function get(
  route,
  payload,
  canRemovePreviousCalls
) {
  if (canRemovePreviousCalls || canRemovePreviousCalls === undefined) {
    this.abortAll();
  }

  const cancelable = getCancelable();
  const request = this.api.get(route, payload, cancelable.token);
  this.add(cancelable);

  return request;
};

export default ApiConcurrencyService;
